export default {

    // Table config settings for column viewing

    config: {
        results_per_page: 30,
        results_per_page_options: [
            30, 
            50,
            100,
            200
        ],
    },

    /*
    COLUMNS: Whatever ones are set to true will be 
    the ones displayed one the list pages by default.
    
    Note: If you set one to true and it doesn't show
    on the front-end, it's probably missing the 
    <el-table-column> within the table.
    */

    /*
    SORT BY: Whatever one is set to true will be 
    the one sent to the backend and it will return the 
    results sorted by your selection (i.e. name, id, etc.)
    
    IMPORTANT: SET EVERYTHING ELSE TO FALSE
    */

    products: {
        columns: {
            id: true,
            name: true,
            sku: true,
            description: false,
            short_description: false,
            enabled: true,
            track_inventory: false,
            stock_level: false,
            total_sold: false,
            specification: false,
            is_editable: false,
            allow_backorder: false,
            print_type_name: false,
            tax_class_name: false,
            created_user_id: false,
            updated_user_id: false,
            created_at: true,
            updated_at: true
        },

        sort_by: {
            id: true,
            name: false,
            sku: false,
            enabled: false,
            track_inventory: false,
            stock_level: false,
            total_sold: false,
            is_editable: false,
            print_type_id: false,
            tax_class_id: false,
            created_at: false,
            updated_at: false
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    users: {
        columns: {
            id: true,
            login: false,
            firstName: true,
            lastName: true,
            email: true,
            status: true,
            created_user_id: false,
            updated_user_id: false,
            user_access_id: false,
            created_at: true,
            updated_at: true,
            last_login: false,
            supplier_id: false,
            user_access: false,
            user_roles: false,
            user_profile: false,
            type: false
        },

        sort_by: {
            id: true,
            login: false,
            firstName: false,
            lastName: false,
            email: false,
            status: false,
            created_user_id: false,
            updated_user_id: false,
            user_access_id: false,
            created_at: false,
            updated_at: false,
            last_login: false,
            supplier_id: false,
            user_access: false,
            user_roles: false,
            user_profile: false,
            type: false
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    templates: {
        columns: {
            id: false,
            name: true,
            display_name: true,
            description: false,
            size: false,
            thumbnail_url: false,
            thumbnail_img: true,
            product_id: false,
            company_id: false,
            editable_products: false,
            is_private: true,
            created_at: true,
            updated_at: true,
            corporation: false,
            current_template_count: false,
        },

        sort_by: {
            id: true,
            name: false,
            display_name: false,
            description: false,
            size: false,
            thumbnail_url: false,
            thumbnail_img: false,
            product_id: false,
            company_id: false,
            editable_products: false,
            is_private: false,
            created_at: false,
            updated_at: false,
            corporation: false,
            current_template_count: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    //BEN NEW:


    product_types: {
        columns: {
            id: true,
            name: true,
            description: true,
            sort_order: true,
            tax_class_name: true,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            description: false,
            sort_order: false,
            tax_class_id: true,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    product_categories: {
        columns: {
            id: true,
            name: true,
            sort_order: true,
            is_hidden: true,
            products_count: false,
            created_user_id: false,
            updated_user_id: false,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            sort_order: false,
            is_hidden: false,
            products_count: false,
            created_user_id: false,
            updated_user_id: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    print_types: {
        columns: {
            id: true,
            name: true,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    taxes: {
        columns: {
            id: true,
            name: true,
            description: true,
            sort_order: false,
            created_user_id: false,
            updated_user_id: false,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            description: false,
            sort_order: false,
            created_user_id: false,
            updated_user_id: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    product_tags: {
        columns: {
            id: true,
            name: true,
            created_user_id: true,
            updated_user_id: true,
            sort_order: true,
            tag_is_hidden: true,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            created_user_id: false,
            updated_user_id: false,
            sort_order: false,
            tag_is_hidden: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    shipping_methods: {
        columns: {
            id: true,
            name: true,
            description: true,
            tracking_url: true,
            support_email: false,
            support_number: false,
            sort_order: false,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            description: false,
            tracking_url: false,
            support_email: false,
            support_number: false,
            sort_order: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    payment_methods: {
        columns: {
            id: true,
            name: true,
            description: true,
            sort_order: true,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            description: false,
            sort_order: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    suppliers: {
        columns: {
            id: true,
            name: true,
            code: true,
            order_notification_email: true,
            created_user_id: false,
            updated_user_id: false,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            order_notification_email: false,
            created_user_id: false,
            updated_user_id: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    corporations: {
        columns: {
            id: true,
            name: true,
            corporateUID: true,
            portal_ip: false,
            portal_url: false,
            backend_portal_url: false,
            notes: false,
            hq_fee: false,
            site_fee: false,
            licence_count: false,
            account_manager_name: true,
            created_user_id: false,
            updated_user_id: false,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            corporateUID: false,
            portal_ip: false,
            portal_url: false,
            backend_portal_url: false,
            notes: false,
            hq_fee: false,
            site_fee: false,
            licence_count: false,
            account_manager: false,
            created_user_id: false,
            updated_user_id: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },

    orders: {
        columns: {
            id: true,
            pim_corporation_name: true,
            pim_url: true,
            created_at: true,
            updated_at: true,
            created_user_id: false,
            updated_user_id: false
        },

        sort_by: {
            id: true,
            pim_corporation_name: false,
            pim_url: false,
            created_at: false,
            updated_at: false,
            created_user_id: false,
            updated_user_id: false
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    template_categories: {
        columns: {
            id: true,
            name: true,
            url_name: true,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            url_name: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    pricing_tiers: {
        columns: {
            id: true,
            country: false,
            state: false,
            zip: false,
            city: false,
            min_qty: true,
            max_qty: true,
            product_cost_price: true,
            product_retail_price: true,
            product_turnaround_time: false,
            pack_weight: false,
            pack_discount: false,
            pack_max_quantity: false,
            pack_cost_price: false,
            pack_retail_price: false,
            pack_width: false,
            pack_height: false,
            pack_depth: false,
            min_weight: false,
            max_weight: false,
            min_volume: false,
            max_volume: false,
            min_subtotal: false,
            max_subtotal: false,
            created_at: true,
            updated_at: true,
            supplier_name: true,
            tax_class_name: false,
            print_type_name: false,
        },

        sort_by: {
            id: true,
            country: false,
            state: false,
            zip: false,
            city: false,
            min_qty: false,
            max_qty: false,
            product_cost_price: false,
            product_retail_price: false,
            product_turnaround_time: false,
            pack_weight: false,
            pack_discount: false,
            pack_max_quantity: false,
            pack_cost_price: false,
            pack_retail_price: false,
            pack_width: false,
            pack_height: false,
            pack_depth: false,
            min_weight: false,
            max_weight: false,
            min_volume: false,
            max_volume: false,
            min_subtotal: false,
            max_subtotal: false,
            created_at: false,
            updated_at: false,
            supplier_name: false,
            tax_class_name: false,
            print_type_name: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },


    pricing_tiers_quote: {
        columns: {
            id: false,
            country: false,
            state: false,
            zip: false,
            city: false,
            min_qty: true,
            max_qty: false,
            max_qty: true,
            product_cost_price: true,
            product_retail_price: true,
            product_turnaround_time: false,
            pack_weight: false,
            pack_discount: false,
            pack_max_quantity: false,
            pack_cost_price: false,
            pack_retail_price: false,
            pack_width: false,
            pack_height: false,
            pack_depth: false,
            min_weight: false,
            max_weight: false,
            min_volume: false,
            max_volume: false,
            min_subtotal: false,
            max_subtotal: false,
            created_at: false,
            updated_at: false,
            supplier_name: true,
            tax_class_name: false,
            print_type_name: false,
            margin: true
        },
    },

    product_category_groups: {
        columns: {
            thumbnail: true,
            id: false,
            name: true,
            sort_order: true,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: true,
            name: false,
            thumbnail: false,
            sort_order: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    },

    user_access: {
        columns: {
            id: true,
            name: true,
            revoked_by: false,
            created_at: true,
            updated_at: true,
        },

        sort_by: {
            id: false,
            name: false,
            revoked_by: false,
            created_at: false,
            updated_at: false,
        }, 

        order_by: {
            desc: true,
            asc: false
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/Tables.js